<template>
	<div class="wrapper-graphic" :style="`color:${$appColors.secondary}`">
		<img 
			:src="data.urlImage" 
			:alt="data.name"
			class="image">
		<p class="mb-0">{{data.name}}</p>
	</div>
</template>
<script>
export default {
	name: 'text-graphic',
	props: {
		data: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-graphic {
		font-family: map-get($fonts, bold);
		font-size: map-get($sizes, sbig);
		text-align: center;
		text-transform: uppercase;
		
		.image {
			margin-bottom: 21px;
		}

		.mb-0 {
			margin-bottom: 0;
		}
	}
</style>





// WEBPACK FOOTER //
// src/modules/job-evaluation/components/text-graphic.vue